import React, { createContext, useState } from 'react';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [isUKTheme, setIsUKTheme] = useState(false);

  const toggleTheme = () => {
    setIsUKTheme((prev) => !prev);
  };

  return (
    <ThemeContext.Provider value={{ isUKTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
